<div *ngIf="event" [ngClass]="{'dark-theme': darkMode}">
    <!--Tickets -->
    <div class="m-t-5">
        <div class="font-12 text-muted">
            <span *ngIf="!isExpanded && event.description.length <= 130" [innerHTML]="event.description"></span>
            <div *ngIf="!isExpanded && event.description.length > 130" class="cursor-pointer">
                <span [innerHTML]="event.description.substring(0, 130) + '... <b>Ver más</b>'" (click)="toggleDesc()"></span>
            </div>
            <span [innerHTML]="event.description" *ngIf="isExpanded" (click)="toggleDesc()"></span>
            <span *ngIf="isExpanded" class="d-flex-center cursor-pointer font-bold" (click)="toggleDesc()">Ver menos</span>
        </div>
        <!-- audiences -->
        <div *ngIf="event.audiences > 0 && (event.type != 21 && event.type != 22)" class="font-12">
            <div *ngIf="event.audiences == 1"><i class="mdi mdi-account-outline mr-1 font-bold"></i>+18</div>
            <div *ngIf="event.audiences == 2"><i class="mdi mdi-account-group-outline mr-1 font-bold"></i>Todo Público</div>
            <div *ngIf="event.audiences == 3"><i class="mdi mdi-account-group-outline mr-1 font-bold"></i>Familiar</div>
            <div *ngIf="event.audiences == 4"><i class="mdi mdi-teddy-bear mr-1 font-bold"></i>Niños y niñas</div>
        </div>
        <!-- address -->
        <div *ngIf="event.addressDetails" class="font-12">
            <i class="mdi mdi-map-marker-outline mr-1 font-bold"></i>Dirección: {{event.addressDetails}}
        </div> 
        <!-- contact info -->
        <div *ngIf="event.email || event.phone || event.whatsappPhone" class="m-b-10 d-flex font-12" (click)="onOpen(contactModal)">
            <i class="mdi mdi-message-text-outline mr-1 font-bold"></i><span style="text-decoration: underline;">Ver info de contacto</span>
        </div>
        <!-- waze -->
        <div *ngIf="event.wazeLink" class="font-12">
            <a [href]="event.wazeLink" style="text-decoration: underline; color: #4DCAFF;">Abrir Waze</a>
        </div>

        <!-- tickets -->
        <div class="text-center font-16 font-bold m-b-10 m-t-10">
            {{event.type == 1 || event.type == 2 ? 'Entradas' : event.type == 21 || event.type == 22 ? 'Opciones' : 'Tickets'}}
        </div>

        <div *ngIf="tickets?.length">
            <div class="nav-pills no-padding">
                <!-- Other tickets -->
                <ng-container *ngFor="let ticket of tickets">
                    <div class="p-1">
                        <a class="btn btn-box-rounded m-b-20 m-r-10 font-c3 btn-tag-light w-100" style="position: relative;">
                            <div>
                                <div class="border-bottom p-b-10">
                                    <!-- Ticket Name -->
                                    <div class="text-left">
                                        <div class="d-flex-between">
                                            <div class="font-h7 w-100 pr-1">
                                                <span *ngIf="ticket.name.length > 62">
                                                    {{ticket.name.substring(0, 59) + ' ...'}}
                                                </span>
                                                <span *ngIf="ticket.name.length <= 62">
                                                    {{ticket.name}}
                                                </span>
                                            </div> 
                                            <div *ngIf="ticket.quantityOfPlaces > 0 && event.type == 1 || event.type == 2" class="text-muted font-14" [ngClass]="darkMode ? 'dark-icon' : 'light-icon'"  style="width: 53px;">
                                                (<i *ngIf="ticket.quantityOfPlaces == 1" class="mdi mdi-account"></i>
                                                <i *ngIf="ticket.quantityOfPlaces > 1" class="mdi mdi-account-multiple"></i>
                                                {{ticket.quantityOfPlaces}})
                                            </div>
                                        </div> 
                                        <div class="position-givi-icons">
                                            <i class="mdi mdi-information text-primary ml-1" (click)="infoOpen(ticket)" style="font-size: 24px;"></i>
                                        </div>
                                    </div>
                                    <div *ngIf="event.type == 1 || event.type == 2" class="font-c2 text-left" style="padding: 10px 0px;">
                                        <span *ngIf="ticket.description.length <= 150" [innerHTML]="ticket.description"></span>
                                        <ng-container *ngIf="ticket.description.length > 150">
                                            <span [innerHTML]="ticket.description.substring(0, 150) + ' ...'"></span>
                                        </ng-container>
                                    </div>
                                </div>
                                <!-- Quantity -->
                                <div class="m-t-5">
                                    <!-- Cashless from checkout -->
                                    <div *ngIf="ticket.ticketStatus == 'Venta Activa' && !ticket.isOutOfStock && !event.isOutOfStock">
                                        <div class="d-flex-between">
                                            <div>
                                                <app-market-ticket-quantity [model]="ticket" [availableQuantityByEvent]="ticket.eventObj.stock - ticket.eventObj.quantity"
                                                [eventIsGeneric]="ticket.eventObj.isGeneric" [availableQuantity]="ticket.availableQuantityByTicket"
                                                [quantityOfPlaces]="ticket.quantityOfPlaces" [eventType]="ticket.eventObj.type" [ticketStock]="ticket.stock" [eventStock]="ticket.eventObj.stock"
                                                [purchaseLimit]="ticket.purchaseLimit"
                                                (change)="onChangeQuantity($event)"></app-market-ticket-quantity>
                                            </div>
                                            <div *ngIf="ticket.price > 0" class="text-left m-t-8 text-truncate" style="font-size: 12px;">
                                                <span class="text-muted">Precio: </span>{{(ticket.price) | currency: ticket?.currencySymbol : 'symbol': '1.0'}}
                                            </div> 
                                            <div *ngIf="ticket.price <= 0" class="text-left m-t-8 text-truncate" style="font-size: 12px;">
                                                <span class="text-muted">Precio: </span>Gratis
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="font-h7" *ngIf="ticket.ticketStatus == 'Fuera de período de venta'">
                                        Fuera de período de venta
                                        <div class="m-t-5 text-muted font-10" style="letter-spacing: 1px;">
                                            Finalizó: {{ticket.saleDateEndAt | date: 'dd MMM yyyy - h:mm a'}}
                                        </div>
                                    </div>
                                    <div class="font-h7" *ngIf="ticket.ticketStatus == 'Sold Out'">
                                        Agotado
                                    </div>
                                    <div class="font-h7" *ngIf="ticket.ticketStatus == 'Programada'">
                                        Pronto
                                        <div class="m-t-5 text-muted font-10" style="letter-spacing: 1px;">
                                            {{getReadyToSaleTimeText(ticket)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Selected tickets -->
    <div *ngFor="let ticket of selectedTickets" class="d-flex-between" [ngClass]="event.type == 21 || event.type == 22 ? '' : 'border-bottom m-b-10'">
            <div class="font-bold font-12" style="line-height: 24px;">
                <span class="text-left" *ngIf="ticket.name.length > 45">
                    {{ticket.name.substring(0, 42) + ' ...'}}
                </span>
                <span class="text-left" *ngIf="ticket.name.length <= 45">
                    {{ticket.name}} x {{ticket.quantitySelected}}
                </span>
            </div>
            <div class="text-right" style="padding: 0 !important; width: 45px;">
                <span *ngIf="(ticket.quantitySelected * ticket.price) > 0" class="font-12">
                    {{(ticket.quantitySelected * ticket.price) | currency: ticket?.currencySymbol : 'symbol': '1.0'}}
                </span>
                <span *ngIf="(ticket.quantitySelected * ticket.price) <= 0" class="font-12">
                    Gratis
                </span>
            </div>
    </div>

    <!-- Ticket -->
    <div class="d-flex justify-content-between">
        <!--Total-->
        <div *ngIf="total > 0" class="font-b1 font-bold">
            Total: <b class="text-purple">({{(total) | currency: tickets[0]?.currencySymbol : 'symbol': '1.0'}})</b>
        </div>
    </div> 
</div>


<ng-template #contactModal let-modal>
    <div class="p-20">
        <div class="d-flex-between p-b-10 border-bottom">
            <div class="font-h5">Info de Contacto</div>
            <div class="cursor-pointer" (click)="onClose()">
                <i class="mdi mdi-close-circle-outline" style="font-size: 21px;"></i>
            </div>
        </div>
        <div class="m-t-20 d-flex-center">
            <i class="mdi mdi-message-text-outline" style="font-size: 32px;"></i> 
        </div>  
        <div class="m-t-20">
            <div *ngIf="event.email" class="m-t-10"><b>Correo: </b> {{event.email}}</div>
            <div *ngIf="event.phone" class="m-t-10"><b>Teléfono: </b> {{event.phone | mask: '0000-0000'}}</div>
            <div *ngIf="event.whatsappPhone" class="m-t-10" (click)="onSendMessage(event.whatsappPhone)"><b>Whatsapp: </b> <span style="color: #4DCAFF;">Enviar mensaje</span></div>
        </div> 
        <div class="m-t-20 d-flex-center">
            <div class="font-c1 text-muted" (click)="onClose()">CERRAR</div>
        </div>
    </div>
</ng-template>